import { render } from "./SuccessStory.vue?vue&type=template&id=6879d749&scoped=true"
import script from "./SuccessStory.vue?vue&type=script&lang=js"
export * from "./SuccessStory.vue?vue&type=script&lang=js"

import "./SuccessStory.vue?vue&type=style&index=0&id=6879d749&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6879d749"]])

export default __exports__